import { motion } from "framer-motion";

/**
 * Slow editorial marquee. Duplicates its children twice and
 * loops them with a translate — creating an endless seamless
 * strip. Designed to sit between hero-adjacent sections as a
 * "band" moment. Kept intentionally low-key: brass tick marks
 * separate each phrase.
 */
export default function Marquee({
  items = [],
  duration = 60,
  className = "",
}) {
  const strip = [...items, ...items];

  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden select-none ${className}`}
      aria-hidden
    >
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {strip.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center gap-14 pr-14"
          >
            <span className="font-display font-light text-[8vw] md:text-[6vw] leading-none tracking-tightest">
              {item}
            </span>
            <span className="text-brass text-3xl md:text-4xl" aria-hidden>
              ✳
            </span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
